import React, { useRef, useState, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStopwatch } from '@fortawesome/pro-regular-svg-icons'
import { selectCalculatedTimers, selectAreTimersAlarming } from 'selectors/timerSelectors'
import TimerContext from './TimerContext'
import { openTimersModal } from './TimersModal.jsx'
import Timer from './Timer.jsx'

const MENU_TIMERS_VISIBLE_MAX = Infinity

const TIMER_W = 120
const TIMER_MARGIN = 10
const TIMER_W_OUTER = TIMER_W + TIMER_MARGIN
const TIMER_COUNT_W = 45
const TIMER_COUNT_MARGIN = 12
const TIMER_COUNT_W_OUTER = TIMER_COUNT_W + TIMER_COUNT_MARGIN

const TimerMenuStyleBlock = React.memo(props => (
  <style type="text/css">{`
    .timer-menu-timers .timer-timer {
      width: ${TIMER_W}px;
      margin-left: ${TIMER_MARGIN}px;
    }
  `}</style>
))

const timerContext = {
  view: 'menu'
}

const TimerMenu = React.memo(props => {
  const timersRef = useRef(null)
  const [timerVisibleCount, setTimerVisibleCount] = useState(0)
  let instances = useSelector(selectCalculatedTimers)
  const areTimersAlarming = useSelector(selectAreTimersAlarming)

  useLayoutEffect(() => {
    const timerSpacesAvailable = Math.floor((props.flexSpaceForTimers) / TIMER_W_OUTER)
    //console.debug('timerSpacesAvailable', timerSpacesAvailable)
    setTimerVisibleCount(
      Math.min(timerSpacesAvailable, MENU_TIMERS_VISIBLE_MAX)
    )
  }, [props.flexSpaceForTimers])

  const handleCountClick = () => {
    openTimersModal({ clinicLocation: props.clinicLocation })
  }
  // filter out any timers that don't belong to the clinic if
  // All locations (-1) isn't the selected clinic
  if (props.clinicLocation != -1) {
    instances = instances.filter(timer => {
      return timer.clinic_id == props.clinicLocation
    })
  }

  if (instances.length <= 0) {
    return null
  }

  const countClassName = areTimersAlarming ? 'alarming' : ''

	return (
    <>
      <div ref={timersRef} className="timer-menu-timers">
        <TimerContext.Provider value={timerContext}>
          {instances.slice(0, timerVisibleCount).map(timer => (
            <Timer
              key={timer.timer_id}
              timerId={timer.timer_id}
              indicatorR={11.5}
            />
          ))}
          <TimerMenuStyleBlock />
        </TimerContext.Provider>
      </div>
      {
        timerVisibleCount < instances.length
        ?
          <div className="timer-menu">
            <div className={`timer-menu-count ${countClassName}`} onClick={handleCountClick}>
              <div className="timer-menu-count-icon">
                <FontAwesomeIcon icon={faStopwatch} />
              </div>
              <div className="timer-menu-count-label">
                {instances.length}
              </div>
            </div>
          </div>
        :
          null
      }
    </>
  )
})

export default TimerMenu
